import { Box, Button, Card, CircularProgress, Container, Grid, IconButton, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { useAcceptCallSheetInvitationMutation, useGetCallSheetLazyQuery, useGetInfoCallSheetParticipantLazyQuery } from '../../../../graphql/generated/graphql'
import { IInfoCard } from '../../../config/interfaces'
import { formatTime } from '../../../helper/converters'
import { CallsheetCard } from './CallsheetCard'
import {
    setDateCallSheet,
    setIdCallSheet,
    setTimeCallSheet,
} from "../../../hooks/callSheet";
import './index.scss'
import InfoCard from './InfoCard'
import ProjectCard from './ProjectCard'
import LocationCard from './LocationCard'
import CrewCallShheetCard from './CrewCard'
import CreativeFile from './CreativeFile'
import ScheduleTableCard from './ScheduleCard'
import { LogoMiniSVG } from "../../../assets/svg/index";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { green } from '@mui/material/colors'

const ConfirmCallsheetPage = () => {

    const params = useParams()
    const [searchParams, setSearchParams] = useSearchParams();
    const [acceptCallSheetInvitation] = useAcceptCallSheetInvitationMutation();
    const [isLoadingConfirm, setIsLoadingConfirm] = useState<boolean>(false);
    const [isLoadingInfoUser, setIsLoadingInfoUser] = useState<boolean>(false);
    const [locations, setLocations] = useState<any>([]);
    const [schedule, setSchedule] = useState<any>([]);
    const [assignedByCategory, setAssignedByCategory] = useState<any>([]);
    const [dayStar, setDayStart] = useState("");
    const [dayEnd, setDayEnd] = useState("");
    const [weather, setWeather] = useState<any>([]);
    const [infoCard, setInfoCard] = useState<IInfoCard>({
        date: "",
        breakfast: "",
        crew: "",
        shooting: "",
        lunch: "",
        meal: "",
        wrap: "",
    });
    const [getCallsheetData, { data: dataUpdate }] = useGetCallSheetLazyQuery();
    const [getInfoCallSheetParticipantData, { data: infoUser, refetch }] = useGetInfoCallSheetParticipantLazyQuery();

    const idUser = searchParams.get("user");
    const idCallsheet = searchParams.get("callsheet");

    useEffect(() => {
        if (typeof idUser === "string" && typeof idCallsheet === "string") {
            setIsLoadingInfoUser(true);
            getInfoCallSheetParticipantData({
                variables: {
                    call_sheet_id: idCallsheet,
                    participant_id: idUser
                },
            }).then(res => setIsLoadingInfoUser(false))
        }
    }, []);

    const handleConfirmCallsheet = () => {
        if (typeof idUser === "string" && typeof idCallsheet === "string") {
            setIsLoadingConfirm(true)
            acceptCallSheetInvitation({
                variables: {
                    userId: idUser,
                    callSheetId: idCallsheet,
                },
            }).then((res) => {
                refetch().then(res => {
                    setIsLoadingConfirm(false);
                })
            })
        }
    }

    useEffect(() => {
        if (idCallsheet) {
            getCallsheetData({
                variables: {
                    call_sheet_id: idCallsheet,
                },
            }).then((data) => {
                if (data?.data?.getCallSheet) {
                    const callsheet = data.data.getCallSheet;
                    const infoCard: any = {};
                    const updatedLocations = [];
                    const date = callsheet?.date?.split(" ");
                    callsheet?.events?.map(
                        (item: any) => (infoCard[item?.name] = item?.time)
                    );
                    let count = 0;
                    const updateLocations = callsheet.location?.map((location) => {
                        const isEnable = location?.assigned_in_call_sheet;
                        if (isEnable) count++;
                        return { ...location, order: isEnable ? count : null };
                    });
                    const sortLocation =
                        updateLocations?.filter((location) => location.order) || [];
                    const nullLocation =
                        updateLocations?.filter((location) => !location.order) || [];
                    updatedLocations.push(...sortLocation);
                    updatedLocations.push(...nullLocation);
                    if (callsheet?.schedule) {
                        const scheduleData = callsheet?.schedule.map((row: any) => ({
                            id: row.id,
                            cast: row.cast,
                            description: row.description,
                            location: row.location,
                            scene: row.scene,
                            time: formatTime(row.time),
                        }));
                        setSchedule(scheduleData);
                    }
                    setLocations(updatedLocations);
                    if (callsheet.participant_by_category) {
                        const participants = callsheet.participant;
                        let participantData: any = [];

                        const participantAssignedFiltered =
                            callsheet.participant_by_category.map((group) => {
                                const deleteDuplicate = group?.users?.filter((value, index, self) =>
                                    index === self.findIndex((t) => (
                                        t.email === value.email
                                    ))
                                )
                                const userData = deleteDuplicate?.filter(
                                    (item) => item.assigned_in_call_sheet
                                );
                                const noAssigned = deleteDuplicate?.filter(
                                    (item) => item.assigned_in_call_sheet === false
                                );
                                if (noAssigned && noAssigned?.length > 0) {
                                    noAssigned.map((ele: any) => {
                                        const match = participants?.filter(
                                            (el: any) => el.user.email === ele.email
                                        )[0];
                                        if (match)
                                            participantData = participantData.concat({
                                                ...match,
                                                time: callsheet.time ? formatTime(callsheet?.time) : "",
                                            });
                                    });
                                }
                                return {
                                    name: group?.name,
                                    users: userData?.map((e: any) => {
                                        const person: any = participants?.find(
                                            (ele: any) => ele.user.email === e.email
                                        );
                                        if (person) {
                                            participantData.push({
                                                ...person,
                                                time: formatTime(e.time_call_sheet),
                                            });
                                        }
                                        return {
                                            time: e.time_call_sheet,
                                            email: e.email,
                                            full_name: e.full_name,
                                            phone: e.phone,
                                            job_title: e.job_title
                                        };
                                    }),
                                };
                            });
                        setAssignedByCategory(participantAssignedFiltered);
                    }
                    setInfoCard(infoCard);
                    setDateCallSheet(date[0] + "T00:00:00");
                    setDayEnd(callsheet?.day_final?.toString() ?? "");
                    setDayStart(callsheet?.day_start?.toString() ?? "");
                    if (callsheet?.time) {
                        setTimeCallSheet(formatTime(callsheet.time));
                    }
                    if (callsheet.temperature) {
                        setWeather([
                            {
                                temp: callsheet.temperature,
                                tempmax: callsheet.temperature_max,
                                tempmin: callsheet.temperature_min
                            }])
                    }
                }
            });
        }
        setDateCallSheet(new Date().toString());
        setIdCallSheet(params.projectId ?? "");
    }, []);

    return (
        <>
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    display: 'flex',
                    width: '100%',
                    backgroundColor: 'black',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    minHeight: '50px'
                }}
            >
                <Box
                    sx={{
                        height: '50px',
                    }}
                >
                    <IconButton
                        href="/"
                        sx={{
                            width: "50px",
                            height: "50px"
                        }}
                    >
                        <LogoMiniSVG />
                    </IconButton>
                </Box>
                <Box
                    className='box-nameUser'
                >
                    Call sheet for {infoUser?.getInfoCallSheetParticipant?.user_name}
                </Box>
                <Box
                    sx={{
                        paddingRight: '1rem'
                    }}
                >
                    <a
                        className='view-pdf-link-file'
                        target='_blank'
                        href={dataUpdate?.getCallSheet?.s3_url
                            ? dataUpdate?.getCallSheet?.s3_url : ''}>
                        PDF
                    </a>
                </Box>
            </Box>
            <Container className='container' >
                <div className='container-card'>
                    <Card
                        className='header-card'
                    >
                        <>
                            {!isLoadingInfoUser &&
                                (!infoUser?.getInfoCallSheetParticipant?.confirmation_date) &&
                                <>
                                    <Box>
                                        <Typography
                                            component="h3"
                                            variant="h3"
                                            sx={{
                                                textAlign: 'center'
                                            }}
                                        >
                                            Please confirm your call time.
                                        </Typography>
                                    </Box>
                                    <Box>
                                        <Button
                                            className='button-confirm'
                                            onClick={handleConfirmCallsheet}
                                        >
                                            {isLoadingConfirm ?
                                                <CircularProgress
                                                    color='secondary'
                                                    size={30}
                                                />
                                                : 'Confirm Call Time'
                                            }
                                        </Button>
                                    </Box>
                                </>
                            }
                            {!isLoadingInfoUser &&
                                (infoUser?.getInfoCallSheetParticipant?.confirmation_date) &&
                                <>
                                    <Box>
                                        <Typography
                                            component="h3"
                                            variant="h3"
                                            sx={{
                                                textAlign: 'center'
                                            }}
                                        >
                                            You confirmed your call sheet. Thank you!
                                        </Typography>
                                    </Box>
                                    <Box>
                                        <CheckCircleIcon sx={{ color: green[600], fontSize: 50 }} />
                                    </Box>
                                </>
                            }
                            {isLoadingInfoUser &&
                                < Box >
                                    <CircularProgress
                                        size={20}
                                    />
                                </Box>
                            }
                        </>
                    </Card>
                </div>
                <div>
                    <Container maxWidth="lg">
                        <Grid>
                            <>
                                <div className="main-card">
                                    <Grid
                                        container
                                        spacing={2}
                                    >
                                        <Grid
                                            item
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            xl={4}
                                            sx={{ display: "flex" }}
                                        >
                                            <CallsheetCard currentProject={dataUpdate?.getCallSheet?.project} />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            xl={4}
                                            sx={{ display: "flex" }}
                                        >
                                            <ProjectCard
                                                numProject={dataUpdate?.getCallSheet?.project?.num_project}
                                                urlAvatar={dataUpdate?.getCallSheet?.project?.client_logo_url}
                                                title={dataUpdate?.getCallSheet?.project?.project_name}
                                                timeGeneral={dataUpdate?.getCallSheet?.time}
                                                timeParticipant={infoUser?.getInfoCallSheetParticipant?.time}
                                                category={dataUpdate?.getCallSheet?.category}
                                                comment={dataUpdate?.getCallSheet?.comment}
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            xl={4}
                                            sx={{ display: "flex" }}
                                        >
                                            <InfoCard
                                                weather={weather}
                                                dayStar={dayStar}
                                                dayEnd={dayEnd}
                                                zipcode={
                                                    locations.length > 0 && locations[0].zipcode
                                                        ? locations[0].zipcode
                                                        : ""
                                                }
                                                infoCard={infoCard}
                                            />
                                        </Grid>
                                    </Grid>
                                </div>
                                <div className="location-wrapper">
                                    <h2>
                                        Locations
                                    </h2>
                                    {
                                        locations.filter((item: any) => item.assigned_in_call_sheet === true)
                                            .map((location: any, index: number) => (
                                                <Box key={index}>
                                                    <LocationCard
                                                        key={location.id}
                                                        index={index}
                                                        location={location}
                                                    />
                                                </Box>))
                                    }
                                </div>
                                <div className="crew-wrapper">
                                    <h2>
                                        Crew
                                    </h2>
                                    <CrewCallShheetCard
                                        assigned={dataUpdate?.getCallSheet?.participant_by_category}
                                        participants={assignedByCategory}
                                    />
                                </div>
                                <div className="schedule-wrapper">
                                    <h2>
                                        Schedule
                                    </h2>
                                    <ScheduleTableCard scheduleProps={schedule} />
                                </div>
                                <div className="creative-documents-wrapper">
                                    <h2>
                                        Creative documents
                                    </h2>
                                    <Grid
                                        container
                                        spacing={2}
                                    >
                                        {dataUpdate?.getCallSheet?.creative_document &&
                                            dataUpdate?.getCallSheet?.creative_document.filter(
                                                (fileCreative: any) => fileCreative.assigned_in_call_sheet === true)
                                                .map((file: any, index: number) => (
                                                    <Grid
                                                        item
                                                        xs={4}
                                                        key={`file-content-${index}`}
                                                    >
                                                        <CreativeFile
                                                            key={index}
                                                            file={file}
                                                            styles={{ backgroundColor: "white" }}
                                                            preview
                                                            removeFile={null}
                                                        />
                                                    </Grid>
                                                ))}
                                    </Grid>
                                </div>
                                <div className="footer-wrapper">
                                    <Box
                                        sx={{
                                            marginBottom: '40px'
                                        }}
                                    >
                                        <a
                                            target='_blank'
                                            href={dataUpdate?.getCallSheet?.s3_url
                                                ? dataUpdate?.getCallSheet?.s3_url : ''}>
                                            View PDF
                                        </a>
                                    </Box>
                                </div>
                            </>
                        </Grid>
                    </Container>
                </div>
            </Container>
        </>
    )
}

export default ConfirmCallsheetPage 